import {utils, write} from 'xlsx';

const exportToXLSX = (data) => {
  const filteredData = data.map(({ key, revenueChart, revenueShare, ...rest }) => {
    const normalized = {};
    for (const [k, v] of Object.entries(rest)) {
      // Convert numeric string to number
      if (typeof v === 'string' && !isNaN(v) && v.trim() !== '') {
        normalized[k] = Number(v);
      } else {
        normalized[k] = v;
      }
    }
    return normalized;
  });

  const workbook = utils.book_new();
  const sheet = utils.json_to_sheet(filteredData);

  // Autofit columns (optional)
  const colWidths = Object.keys(filteredData[0] || {}).map(k => ({
    wch: Math.max(k.length, ...filteredData.map(r => String(r[k] || '').length)) + 2
  }));
  sheet['!cols'] = colWidths;

  utils.book_append_sheet(workbook, sheet, 'Sheet1');
  const xlsxBuffer = write(workbook, { type: 'array', bookType: 'xlsx' });
  const blob = new Blob([xlsxBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'data.xlsx';
  link.click();
  URL.revokeObjectURL(url);
};

export { exportToXLSX };
